import React, { lazy, Suspense } from 'react';

import clientOnly from '../../hoc/clientOnly';

const Graph = lazy(() => import(/* webpackChunkName: "Graph" */ './Graph'));

const Loader = ({ classes, ...props }) => (
  <div className={classes}>
    <Suspense fallback={null}>
      <Graph {...props} />
    </Suspense>
  </div>
);

export default clientOnly(Loader);
